<template>
    <div>
        <main-header></main-header>
        <router-view :key="key"></router-view>
        <main-footer></main-footer>
    </div>
</template>

<script>
import mainFooter from './mainFooter.vue'
import mainHeader from './mainHeader.vue'
export default {
    components: {
        mainFooter,
        mainHeader,
    },
    computed: {
        key() {
            return this.$route.path
        },
    }
}
</script>